import { Text } from "@chakra-ui/react"

const Footer = () => (
  <Text color='#B6B6B6' fontSize='15px' position='absolute' bottom='30px'>
    © Develop By Daksh Patel
  </Text>
)

export default Footer
